import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const eye: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M13-4.5q-1.188-1.84-2.969-2.766.47.816.469 1.766 0 1.439-1.031 2.469A3.34 3.34 0 0 1 7-2Q5.562-2 4.531-3.031C3.844-3.72 3.5-4.54 3.5-5.5q-.001-.95.484-1.766Q2.184-6.339 1-4.5a8.15 8.15 0 0 0 2.61 2.547A6.37 6.37 0 0 0 7-1a6.4 6.4 0 0 0 3.39-.953A8 8 0 0 0 13-4.5M7.266-7.234a.379.379 0 0 0 0-.531.38.38 0 0 0-.266-.11q-.97 0-1.672.703A2.26 2.26 0 0 0 4.625-5.5a.35.35 0 0 0 .11.266q.106.11.265.109a.36.36 0 0 0 .266-.11c.07-.07.109-.16.109-.265 0-.445.156-.828.469-1.14.32-.32.707-.485 1.156-.485a.36.36 0 0 0 .266-.11m6.578 2.187c.101.188.156.371.156.547 0 .18-.055.355-.156.531a8.4 8.4 0 0 1-2.938 2.89Q9.062.002 7 0 4.95 0 3.094-1.078a8.3 8.3 0 0 1-2.938-2.89A1 1 0 0 1 0-4.5q-.002-.265.156-.547a8.3 8.3 0 0 1 2.938-2.86C4.332-8.632 5.633-9 7-9q2.062.002 3.906 1.094a8.34 8.34 0 0 1 2.938 2.86m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 9)"
    />
  ),
  svgProps: {
    height: "9",
    width: "14",
  }
};
